import { AxiosError } from 'axios';

export interface ApiErrorData {
  message: string;
  error: string;
  statusCode: number;
  code?: string;
}

export class ApiError extends Error implements ApiErrorData {
  public readonly statusCode: number;
  public readonly error: string;
  public readonly code: string | undefined;

  constructor(error: AxiosError<ApiErrorData>) {
    super(error.response?.data.message ?? error.message);
    this.statusCode = error.response?.status ?? error.status ?? 500;
    this.error =
      error.response?.data.error ?? error.response?.statusText ?? error.name;
    this.code = error.response?.data.code;
  }
}
